import { render } from "./CostiPratiche.vue?vue&type=template&id=8ee97620&scoped=true"
import script from "./CostiPratiche.vue?vue&type=script&lang=js"
export * from "./CostiPratiche.vue?vue&type=script&lang=js"

import "./CostiPratiche.vue?vue&type=style&index=0&id=8ee97620&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee97620"]])

export default __exports__